

export const epochToDate = (epoch?: number | string) => {
    if (!epoch || Number(epoch) === 0) {
        return "N/A";
    }

    const num = Number(epoch);

    if (isNaN(num)) {
        return "N/A";
    }

    const milliseconds = num < 1e12 ? num * 1000 : num;

    const date = new Date(milliseconds);

    return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
};

export const epochToGMTFormatted = (epoch?: number | string) => {
    if (!epoch || Number(epoch) === 0) {
        return "N/A";
    }

    const num = Number(epoch);

    if (isNaN(num)) {
        return "N/A";
    }

    const milliseconds = num < 1e12 ? num * 1000 : num;

    const date = new Date(milliseconds);

    return date.toLocaleString("en-GB", {
        timeZone: "UTC", // ✅ forces GMT
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
};

